import React from "react";
import { connect } from "react-redux";

import {
  doGetAllOrders,
  doDeleteOrder,
  doBulkDeleteOrders,
  doBulkUpdateOrders,
  doBulkUpdateDeliveryDate,
} from "../stores/thunk";
import { selectAllOrders } from "../stores/slice";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      action: state.order.action,
      isFetching: state.order.isFetching,
      status: state.order.status,
      metadata: state.order.metadata,
      user: state.auth.user,
      message: state.order.message,
      orders: selectAllOrders(state),
    };
  }

  return connect(mapStateToProps, {
    doGetAllOrders,
    doDeleteOrder,
    doBulkDeleteOrders,
    doBulkUpdateOrders,
    doBulkUpdateDeliveryDate,
  })(Container);
};
